import { Component, OnInit, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { Observable, map } from 'rxjs';
import { AdminJob } from '../../models/adminJob';
import { JobAdminService } from '../../services/job-admin.service';
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import {
  DateTimePipe,
  NimmstaTimeAgoPipe,
  StatusBadgePipe,
} from '@nimmsta/ng-commons-lib/pipes';
import { ErrorComponent } from '@nimmsta/ng-commons-lib/error';
import { HeaderBarComponent } from '@nimmsta/ng-commons-lib/header-bar';
import { LoadingIndicatorComponent } from '@nimmsta/ng-commons-lib/loading-indicator';

@Component({
  templateUrl: 'admin-job-detail.component.html',
  imports: [
    TranslatePipe,
    AsyncPipe,
    TitleCasePipe,
    HeaderBarComponent,
    LoadingIndicatorComponent,
    ErrorComponent,
    NimmstaTimeAgoPipe,
    StatusBadgePipe,
    DateTimePipe,
  ],
})
export class AdminJobDetailComponent implements OnInit {
  private jobService = inject(JobAdminService);
  private translate = inject(TranslateService);
  private route = inject(ActivatedRoute);

  error?: HttpErrorResponse;

  job?: AdminJob;

  isLoading = false;

  asString(value: unknown): string {
    return value as string;
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.route.params.subscribe((params) => {
      this.jobService.get(params['id']).subscribe({
        next: (job: AdminJob) => {
          this.job = job;
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.error = error;
          this.isLoading = false;
        },
      });
    });
  }

  getArticleKeys(article: object): string[] {
    return Object.keys(article);
  }

  getHeader(header: string): Observable<string> {
    return this.translate.get('job').pipe(
      map((translations: unknown) => {
        if (translations && typeof translations === 'object') {
          const translatedHeader = (translations as Record<string, unknown>)[
            header
          ];
          if (typeof translatedHeader === 'string') {
            return translatedHeader;
          }
        }

        return header;
      }),
    );
  }
}
